import { useEffect, useState } from "react";
import { useTariff } from "../context/TariffContext";
import Annual from "./CurrentTariff/Annual";
import EditTariffModal from "./CurrentTariff/EditTariffModal";
import Monthly from "./CurrentTariff/Monthly";
import InfoModal from "./InfoModal";
import LoadingCard from "./LoadingCard";
import Tabs from "./Tabs";

const CurrentTariff = ({
  showEditTariffModal,
  setShowEditTariffModal,
  showEditTariffModalError,
  setShowEditTariffModalError,
}) => {
  const {
    isFetchingCurrentTariff,
    isFetchingMonthlySpend,
    hasCompleteTariffInfo,
  } = useTariff();
  const [currentTab, setCurrentTab] = useState("monthly");

  const [showHowSpendCalculatedModal, setShowHowSpendCalculatedModal] =
    useState(false);
  const [showHowUsageCalculatedModal, setShowHowUsageCalculatedModal] =
    useState(false);

  const TariffView = currentTab === "monthly" ? Monthly : Annual;

  const tabs = [
    {
      id: "monthly",
      name: "Monthly figures",
      current: currentTab === "monthly",
    },
    { id: "annual", name: "Annual figures", current: currentTab === "annual" },
  ];

  useEffect(() => {
    if (
      !isFetchingCurrentTariff &&
      !isFetchingMonthlySpend &&
      !hasCompleteTariffInfo
    ) {
      setShowEditTariffModalError(true);
      setShowEditTariffModal(true);
    }
  }, [isFetchingCurrentTariff, isFetchingMonthlySpend]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="space-y-6">
        <Tabs title="Show me:" tabs={tabs} setCurrentTab={setCurrentTab} />
        {!isFetchingCurrentTariff && !isFetchingMonthlySpend ? (
          <TariffView
            setShowHowSpendCalculatedModal={setShowHowSpendCalculatedModal}
            setShowHowUsageCalculatedModal={setShowHowUsageCalculatedModal}
            setShowEditTariffModal={setShowEditTariffModal}
          />
        ) : (
          <>
            <LoadingCard />
            <LoadingCard />
          </>
        )}
      </div>

      <InfoModal
        open={showHowSpendCalculatedModal}
        setOpen={setShowHowSpendCalculatedModal}
        title="How your estimate spend was calculated"
        body={
          <div className="space-y-4">
            <p>
              We use industry data from trusted sources to estimate your energy
              spend. This is based on:
            </p>
            <ul className="pl-[20px] list-disc list-inside">
              <li>Your previous electricity and gas usage</li>
              <li>The cost of energy units based on your tariff</li>
              <li>Your meter readings</li>
            </ul>
            <p>
              We then compare these to other tariffs on the market to see if you
              can save money on your bill. Our estimate doesn’t include any
              outstanding debt you may already have or additional costs your
              energy supplier may charge.
            </p>
            <p>Costs include Value Added Tax (VAT).</p>
          </div>
        }
      />

      <InfoModal
        open={showHowUsageCalculatedModal}
        setOpen={setShowHowUsageCalculatedModal}
        title="How your estimate usage was calculated"
        body={
          <div className="space-y-4">
            <p>
              Your usage has been calculated using info from trusted sources:
              Electralink for electricity and Xoserve for gas.
            </p>
            <p>
              If any data is missing, we'll use the average usage figure for
              your fuel type(s) to give you an estimate. For a more accurate
              figure we recommend checking your latest bill against your
              estimate.
            </p>
          </div>
        }
      />

      <EditTariffModal
        open={showEditTariffModal}
        setOpen={setShowEditTariffModal}
        showError={showEditTariffModalError}
      />
    </>
  );
};

export default CurrentTariff;
